// extracted by mini-css-extract-plugin
export default {"group":"Av4oV","group-item":"RsUv1"};